(function ($, Drupal, once) {

  Drupal.behaviors.provinces = {
    attach: function (context, settings) {

      $('.form-item-c-p', context).append('<p class="c-p-info"></p>');
      $('.form-item-c-p-', context).append('<p class="c-p2-info"></p>');

      $('#edit-pais-term',context).on( "change",function() {
        var valorSeleccionat = $(this).val();
        console.log(valorSeleccionat);

        $('#edit-provincia-term').attr("disabled","disabled");

        // Fer una petició AJAX per obtenir el JSON des de la URL
        $.ajax({
          url: '/provinces',
          type: 'GET',
          dataType: 'json',
          /*beforeSend: function (xhr) {
       xhr.setRequestHeader ("Authorization", "Basic " + btoa("ecoembes-pre.com" + ":" + "Kt1XDZJiJpsH"));
          },*/
          success: function(data) {
            // Ara pots iterar sobre el JSON i ocultar les opcions del selector
            $("#edit-provincia-term").val('').trigger('change');
            $.each(data, function(clau, valor) {
              console.log(valorSeleccionat);
              $('#edit-provincia-term option[value="'+valor.tid+'"]').removeAttr("disabled","disabled");
              $('#edit-provincia-term option[value="'+valor.tid+'"]').removeAttr("selected","selected");

              if (valor.tid_country !== valorSeleccionat && valor.name != 'Otra provincia') {
                $('#edit-provincia-term option[value="'+valor.tid+'"]').attr("disabled","disabled");
              } else {
                if (valor.tid_country == valorSeleccionat && valor.name == 'Otra provincia') {
                  $('#edit-provincia-term option[value="'+valor.tid+'"]').attr("selected","selected");
                  $("#edit-provincia-term").val(valor.tid).trigger('change');
                }
                /*else {
                    $("#edit-provincia-term").val(valor.tid).trigger('change');
                }*/
                $('#edit-provincia-term option[value="'+valor.tid+'"]').removeAttr("disabled","disabled");
              }
            });
          },
          error: function() {
            console.error('Error en carregar el JSON');
          },
          complete: function() {
            $('#edit-provincia-term').removeAttr("disabled","disabled");
          }
        });


        if (valorSeleccionat === '529') {
          // Canviar el patró del camp d'entrada amb l'ID edit-c-p
          $('#edit-c-p',context).attr('pattern', '((0[1-9]|5[0-2])|[1-4][0-9])[0-9]{3}');
          $('.c-p-info',context).text(Drupal.t('El campo debe ser numérico, superior a 1.000 y inferior a 53.000.'));
        } else {
          // Si el valor no és 529, eliminar el patró
          $('#edit-c-p',context).attr('pattern', '^(?!\s*$).+');
          $('.c-p-info',context).text(Drupal.t('El campo no puede estar vacío.'));
        }
      });

      //$('#edit-pais-direccion-envio-term',context).trigger('change');


      $('#form-item-c-p-').append('<p class="c-p2-info"></p>');

      $('#edit-pais-direccion-envio-term',context).on( "change",function() {
        var valorSeleccionat = $(this).val();
        console.log(valorSeleccionat);

        $("#edit-provincia-envio-term").attr("disabled","disabled");

        // Fer una petició AJAX per obtenir el JSON des de la URL
        $.ajax({
          url: '/provinces',
          type: 'GET',
          dataType: 'json',
          success: function(data) {
            // Ara pots iterar sobre el JSON i ocultar les opcions del selector
            $("#edit-provincia-envio-term").val('').trigger('change');
            $.each(data, function(clau, valor) {
              console.log(valorSeleccionat);
              $('#edit-provincia-envio-term option[value="'+valor.tid+'"]').removeAttr("disabled","disabled");
              $('#edit-provincia-envio-term option[value="'+valor.tid+'"]').removeAttr("selected","selected");

              if (valor.tid_country !== valorSeleccionat && valor.name != 'Otra provincia') {
                $('#edit-provincia-envio-term option[value="'+valor.tid+'"]').attr("disabled","disabled");
              } else {
                if (valor.tid_country == valorSeleccionat && valor.name == 'Otra provincia') {
                  $('#edit-provincia-envio-term option[value="'+valor.tid+'"]').attr("selected","selected");
                  $("#edit-provincia-envio-term").val(valor.tid).trigger('change');
                }
                /*else {
                    $("#edit-provincia-envio-term").val(valor.tid).trigger('change');
                }*/
                $('#edit-provincia-envio-term option[value="'+valor.tid+'"]').removeAttr("disabled","disabled");
              }
            });
          },
          error: function() {
            console.error('Error en carregar el JSON');
          },
          complete: function() {
            $('#edit-provincia-envio-term').removeAttr("disabled","disabled");
          }
        });

        if (valorSeleccionat === '529') {
          // Canviar el patró del camp d'entrada amb l'ID edit-c-p
          $('#edit-c-p-',context).attr('pattern', '((0[1-9]|5[0-2])|[1-4][0-9])[0-9]{3}');
          $('.c-p2-info',context).text(Drupal.t('El campo debe ser numérico, superior a 1.000 y inferior a 53.000.'));
        }
        else {
          $('#edit-c-p-',context).removeAttr('pattern');
          $('.c-p2-info',context).text('');
        }
      });



      // Trigger of jquery doesn't work. use next code.
      var sortBySelect = document.querySelector("select#edit-pais-term");
      sortBySelect.value = 529;
      sortBySelect.dispatchEvent(new Event("change"));

      // Trigger of jquery doesn't work. use next code.
      var sortBySelect = document.querySelector("select#edit-pais-direccion-envio-term");
      sortBySelect.value = 529;
      sortBySelect.dispatchEvent(new Event("change"));
    }
  };
})(jQuery, Drupal, once);
